var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:_vm.buttonClass,attrs:{"data-sense":"sense_loan_online_widget","onclick":"SENSE.loanMe()"}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }